import { render } from "./CompanyCard.vue?vue&type=template&id=5f5b8250&scoped=true"
import script from "./CompanyCard.vue?vue&type=script&lang=js"
export * from "./CompanyCard.vue?vue&type=script&lang=js"

import "./CompanyCard.vue?vue&type=style&index=0&id=5f5b8250&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5b8250"]])

export default __exports__